import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { apiClient, formatApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

const NAVY = "#132a63";
const GREEN = "#16a34a";

export default function RegistroProveedor() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [f, setF] = useState({ nombre: "", email: "", celular: "", password: "", nombre_comercial: "", nombre_fiscal: "", rfc: "", direccion_fiscal: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    const cel = f.celular.replace(/\D/g, "");
    if (!f.nombre || !f.email || cel.length < 10 || f.password.length < 6) {
      toast.error("Completa los campos (contraseña mínima 6 caracteres).");
      return;
    }
    setLoading(true);
    try {
      await apiClient.post("/proveedores/register", { ...f, celular: cel });
      await refresh();
      toast.success("Cuenta de proveedor creada");
      navigate("/proveedor");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "No se pudo crear la cuenta.");
    } finally { setLoading(false); }
  };

  return (
    <div style={wrap}>
      <Helmet><title>Registro Proveedor — Mi Ángel Asís</title></Helmet>
      <div style={card} data-testid="proveedor-registro-card">
        <div style={{ textAlign: "center", marginBottom: 16 }}>
          <div style={{ fontSize: 22, fontWeight: 800, color: NAVY }}>Portal de Proveedores</div>
          <p style={{ color: "#6b7280", marginTop: 4, fontSize: 14 }}>Da de alta tu empresa y tus datos de cobro</p>
        </div>
        <form onSubmit={submit}>
          <label style={lbl}>Nombre de contacto</label>
          <input style={inp} value={f.nombre} onChange={set("nombre")} data-testid="pv-nombre" />
          <label style={lbl}>Email</label>
          <input style={inp} type="email" value={f.email} onChange={set("email")} data-testid="pv-email" />
          <label style={lbl}>Celular</label>
          <input style={inp} inputMode="numeric" value={f.celular} onChange={set("celular")} placeholder="55 1234 5678" data-testid="pv-celular" />
          <label style={lbl}>Contraseña</label>
          <input style={inp} type="password" value={f.password} onChange={set("password")} data-testid="pv-password" />
          <label style={lbl}>Nombre comercial</label>
          <input style={inp} value={f.nombre_comercial} onChange={set("nombre_comercial")} data-testid="pv-comercial" />
          <label style={lbl}>Nombre / Razón social fiscal</label>
          <input style={inp} value={f.nombre_fiscal} onChange={set("nombre_fiscal")} data-testid="pv-fiscal" />
          <label style={lbl}>RFC</label>
          <input style={inp} value={f.rfc} onChange={set("rfc")} data-testid="pv-rfc" />
          <label style={lbl}>Dirección fiscal</label>
          <input style={inp} value={f.direccion_fiscal} onChange={set("direccion_fiscal")} data-testid="pv-direccion" />
          <button type="submit" disabled={loading} data-testid="pv-submit"
            style={{ ...btn, background: GREEN, color: "white", marginTop: 18, opacity: loading ? 0.7 : 1 }}>
            {loading ? "Creando…" : "Crear cuenta de proveedor"}
          </button>
        </form>
        <div style={{ textAlign: "center", marginTop: 14 }}>
          <Link to="/proveedor/login" style={{ color: NAVY, fontSize: 13, fontWeight: 600 }} data-testid="pv-go-login">¿Ya tienes cuenta? Inicia sesión</Link>
        </div>
      </div>
    </div>
  );
}

const wrap = { minHeight: "100vh", background: NAVY, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "'Poppins',system-ui,sans-serif" };
const card = { background: "white", color: "#1f2937", borderRadius: 22, padding: "30px 26px", maxWidth: 440, width: "100%", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" };
const lbl = { display: "block", fontSize: 12, fontWeight: 700, color: NAVY, marginTop: 12, marginBottom: 4 };
const inp = { width: "100%", padding: "11px 13px", borderRadius: 10, border: "1px solid #cbd5e1", fontSize: 15, boxSizing: "border-box" };
const btn = { width: "100%", padding: "13px", borderRadius: 999, fontWeight: 800, border: "none", cursor: "pointer", fontSize: 15 };
